import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import * as React from 'react';
import Common from '../utilities/common';
import $ from "jquery";
import { TrameroSearchModel } from '../Tramero/TrameroSearchModel';
import { Apellido } from '../Apellidos/Apellido';

export interface IRepairCodigoPostalProps {
    open: boolean;
    id: number;
    onCancel?: any;
    onSave?: any;
}

export interface IRepairCodigoPostalState {
    tramero: any[];
    searchingTramero: boolean;
    normalizacionItem: any;
    open: boolean;
    hasErrors: boolean;
}

export default class RepairCodigoPostal extends React.Component<IRepairCodigoPostalProps, IRepairCodigoPostalState> {
    _codigoPostal: number = -1;
    _id: number = -1;

    public constructor(props: IRepairCodigoPostalProps) {
        super(props);

        this.state = {
            tramero: [],
            searchingTramero: true,
            open: false,
            normalizacionItem: null,
            hasErrors: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IRepairCodigoPostalProps>, nextContext: any): void {
        this._id = nextProps.id;
        this.setState({
            open: nextProps.open
        });

        this.GetData();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    {
                        `Reparar código postal`
                    }
                </DialogTitle>
                <DialogContent>
                    {
                        !this.state.hasErrors && (
                            <React.Fragment>
                                <Typography variant='body2' style={{marginBottom: '10px'}}>
                                    {
                                        `Introduzca el código postal para el registro`
                                    }
                                </Typography>
                                <TextField 
                                    variant='standard' 
                                    fullWidth 
                                    label='Código postal'
                                    onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                                        this._codigoPostal = Number(event.target.value);
                                    }}
                                ></TextField>
                            </React.Fragment>
                        )
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Save.bind(this)}>Ok</Button>
                    {
                        !this.state.hasErrors && (
                            <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                        )
                    }
                </DialogActions>
            </Dialog>
        )
    }

    private GetData() {
        let url = `${Common.END_POINT}/normalizaciones/data/${this._id}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            let errorsCounter = 0;
            for (let key in response[0]) {

                if(key.toLowerCase() != 'cp' && response[0][key].indexOf != undefined && response[0][key].indexOf('Message') > -1) {
                    errorsCounter++;
                }
            }
            this.setState(
                {
                    normalizacionItem: response[0],
                    hasErrors: errorsCounter > 0
                }
            );
        });
    }

    private Save() {
        if(this.state.hasErrors) {
            this.Close();
            return;
        }
        const normalizacionItem = JSON.parse(JSON.stringify(this.state.normalizacionItem));
        normalizacionItem.cp = this._codigoPostal.toString();

        if(normalizacionItem.fechaNacimiento.indexOf == undefined) {
            normalizacionItem.fechaNacimiento = '';
        }

        let url = `${Common.END_POINT}/normalizaciones/data/${this._id}/update`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(normalizacionItem),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: boolean) => {
            if(this.props.onSave != null) {
                this.props.onSave(response);
            }
        })
    }

    private Close() {
        if(this.props.onCancel != null) {
            this.props.onCancel();
        }
    }
}